import { render, staticRenderFns } from "./Hzhb.vue?vue&type=template&id=0ac988a2"
import script from "./Hzhb.vue?vue&type=script&lang=js"
export * from "./Hzhb.vue?vue&type=script&lang=js"
import style0 from "./Hzhb.vue?vue&type=style&index=0&id=0ac988a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports